import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import PermissionGuard from '@/auth/guard/permission-guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

// Lazy load components
const OpportunitiesListPage = lazy(() => import('@pages/management/accounts/opportunities/list'));
const OpportunityDetailPage = lazy(() => import('@pages/management/accounts/opportunities/detail'));
const OpportunitySummaryPage = lazy(
  () => import('@pages/management/accounts/opportunities/summary')
);

export const opportunityRoutes = [
  {
    path: 'opportunities',
    element: (
      <PermissionGuard
        module={OrionModule.ACCOUNT}
        submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
        access={OrionAccess.VIEW}
        hasContent
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </PermissionGuard>
    ),
    children: [
      {
        path: '',
        element: <OpportunitiesListPage />,
      },
      {
        path: 'summary',
        element: <OpportunitySummaryPage />,
      },
      {
        path: ':id',
        element: (
          <PermissionGuard
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
            access={OrionAccess.VIEW}
            hasContent
          >
            <OpportunityDetailPage />
          </PermissionGuard>
        ),
      },

    ],
  },
];
